export default {
  "Pagination": "_Pagination_ivgjs_1"
};import "ni:sha-256;DWOeX2mphCQGj1GFF8_-n2FuB19wz0kbBwnnkgLG938";